module.exports = __webpack_public_path__ + "static/media/knc-and-dao.1698f5bb.jpeg";